<script setup>
import { getQuesTotalScore } from '@/api/index'
import { getOrderRecord } from '@/api/pay.js'
import { getUserLossRecordList, getUserTotalScore } from '@/api/person.js'
import { onMounted, reactive, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { List, Cell, CellGroup } from 'vant'
import InfoCard from './components/InfoCard.vue'
import { useCommonReviewQuesEffect } from '@/effects/reviewQuesEffect'
import Order from './components/Order.vue'

const route = useRoute()
const router = useRouter()
const store = useStore()

const state = reactive({
  list: [],
  loading: false,
  finished: false,
})

const queryList = {
  pageNo: 0,
  pageSize: 10,
  total: 0,
}


// 是否开启了支付
const isPay = ref(store.getters.getQuesInfo?.payStatus === 2)

const quesTotalScore = ref(null)
// 获取问卷总分
const fetchQuestTotalScore = async () => {
  const res = await getQuesTotalScore({
    questionActiveKey: route.query.questionActiveKey,
  })

  if (res.ok) {
    quesTotalScore.value = res.data.totalScore
  }
}
fetchQuestTotalScore()

// 获取答题记录
const fecthData = async () => {
  queryList.pageNo++
  const func = !isPay.value ? getUserLossRecordList : getOrderRecord
  const res = await func({
    questionActiveKey: route.query.questionActiveKey,
    personKey: route.query.questionActiveKey,
    pageNo: queryList.pageNo,
    pageSize: queryList.pageSize,
    token: store.getters.getToken,
  })

  if (res.ok) {
    state.list = [...state.list, ...res.data.rows]
    queryList.total = res.data.total

    state.loading = false
    if (state.list.length >= res.data.total) {
      state.finished = true
    }
  }
}

const filterLabel = (status) => {
  switch (status) {
    case 0:
      return '已撤销'
    case 1:
      return '待审核'
    case 2:
      return '已通过'
    case 3:
      return '已驳回'
  }
}

const formatLongTime = (longTime) => {
  if (!longTime) return

  if (longTime > 1000 * 60) {
    return `${(longTime / 1000 / 60).toFixed(2)}分`
  } else {
    return `${(longTime / 1000).toFixed(2)}秒`
  }
}

const { handlePriviewClick } = useCommonReviewQuesEffect()

function handleReturnClick() {
  router.push({
    path: '/',
    query: {
      questionActiveKey: route.query.questionActiveKey,
      orgId: store.getters.getOrgId,
    },
  })
}
</script>
<template>
  <template v-if="!isPay">
    <InfoCard  />
    <div v-if="$store.getters.getOrgId !== '21'" class="ques-info">
      <span class="ques-title">{{ $store.getters.getQuesInfo.title }}</span>
      <span v-if="quesTotalScore" class="total-score">
        试卷总分：{{ quesTotalScore }}
      </span>
    </div>
  </template>

  <List
    class="list-wrap"
    :class="{
      'bg-white': !isPay
    }"
    v-model:loading="state.loading"
    :finished="state.finished"
    finished-text="没有更多了"
    @load="fecthData"
  >
    <template
      v-for="item in state.list"
    >
      <Order v-if="isPay" :order="item" @click="handlePriviewClick(item)" />
      <div v-else class="item-wrap van-hairline--bottom" @click="handlePriviewClick(item)" >
        <img class="item-img" src="@/assets/img/person/default-bg.png" alt="" />
        <div class="info-wrap">
          <p class="long-time">
            <span v-if="item.score" class="score">{{ item.score }}分</span>
            <span
              v-if="
                ($store.getters.getOrgId == '303' ||
                  $store.getters.getOrgId == '29') &&
                $store.getters.getQuesInfo.type === 1
              "
              class="status"
              :class="{
                success: item.status === 2,
                error: item.status === 3,
                revoke: item.status === 0,
              }"
              >{{ filterLabel(item.status) }}</span
            >
            共用时
            {{ formatLongTime(item.longTime) }}
          </p>
          <p class="time">{{ item.createTime }}</p>
        </div>
      </div>
    </template>
  </List>
  <button @click="handleReturnClick" class="return-btn">返回首页</button>
</template>
<style lang="scss" scoped>
.ques-info {
  margin: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 34px;
  color: #333;

  .ques-title {
    line-height: 1.5;
  }

  .total-score {
    margin-left: 40px;
    min-width: 200px;
    font-size: 32px;
    color: #666666;
  }
}

.list-wrap {
  margin-top: 20px;
  padding-bottom: 20px;


  .item-wrap {
    display: flex;
    padding: 20px 25px;

    .item-img {
      width: 153px;
      height: 153px;
      border-radius: 8px;
    }

    .info-wrap {
      margin-left: 51px;
      p.long-time {
        margin-top: 20px;
        font-size: 32px;
        font-weight: 400;
        color: #666666;
      }
      span.score {
        margin-right: 30px;
        font-size: 38px;
        font-weight: bold;
        color: #f13636;
      }
      span.status {
        margin-right: 37px;
        font-size: 38px;
        color: #3da3fa;
        font-weight: bold;
      }

      .success {
        color: #00be9c;
      }

      .error {
        color: #f13636;
      }

      .revoke {
        color: #999999;
      }

      .time {
        margin-top: 34px;
        font-size: 28px;
        font-weight: 400;
        color: #999999;
      }
    }
  }
}

.bg-white {
  background-color: #ffffff;
}

.return-btn {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 20px;
  margin: 136px auto;
  display: block;
  width: 700px;
  height: 88px;
  background: linear-gradient(-90deg, #388fff 0%, #2faeff 100%);
  border-radius: 44px;
  border: 1px solid #2faeff;
  font-size: 34px;
  font-weight: 500;
  color: #ffffff;
}
</style>
